import React from 'react';
import TestProfile from '../components/client/ProfileAssistant/testprofile';
import DockingStation from '../components/client/ProfileAssistant/dockingstation';

const TestPage = () => {
  // Add mock auth context for testing
  const mockUser = {
    id: 1,
    name: 'Test User',
    // Add any other user properties your auth context expects
  };

  // Mock the auth context
  const mockAuth = {
    user: mockUser
  };

  return (
    <div className="container mx-auto w-4/5 pt-6">
      <div className="flex flex-col md:flex-row gap-3 min-h-[calc(100vh-6rem)]">
        {/* Left Column - User Info */}
        <div className="w-full md:w-[30%] bg-white rounded-lg p-4 shadow-[0_0_20px_rgba(0,0,150,0.1)] h-fit">
          <div className="mb-6">
            <div className="relative w-32 mx-auto">
              <div className="w-32 h-32 rounded-full bg-gray-200" />
              <div className="absolute -bottom-2 -right-6">
                <div className="relative group">
                  <div className="text-sm font-bold bg-[#00aef7]/10 px-2 py-0.5 rounded-full border border-[#00aef7]/20 text-[#00aef7] cursor-help">
                    Customer Focus
                  </div>
                </div>
              </div>
            </div>
            <h2 className="text-xl font-semibold text-center mb-1 mt-4">John Doe</h2>
            <p className="text-base text-gray-700 text-center mb-2">Territory Manager</p>
            <p className="text-sm text-gray-600 text-center mb-1">555-123-4567</p>
            <p className="text-sm leading-tight text-gray-600 text-center mb-3">john@example.com</p>
            <div className="mt-6 text-center">
              <div className="flex justify-center text-yellow-400">★★★★★</div>
              <p className="text-lg font-bold mt-1">9.4</p>
            </div>
          </div>
        </div>

        {/* Middle Column - Business Info */}
        <div className="w-full md:w-[60%] bg-white rounded-lg p-4 shadow-[0_0_20px_rgba(0,0,150,0.1)] flex flex-col">
          <div className="w-full mb-0">
            <h1 className="text-2xl font-bold break-words text-[#00aef7] leading-tight cursor-pointer">
              Test Company Name
            </h1>
          </div>
          <div className="flex justify-between items-start">
            <div className="flex-1 pt-1.5">
              <p className="text-sm text-gray-600 leading-none">123 Test Street</p>
              <p className="text-sm text-gray-600 leading-normal mb-3">Dallas, TX 75001</p>
              <p className="text-sm text-gray-600 leading-none">555-987-6543</p>
              <p className="text-sm text-gray-600 mt-1">www.testcompany.com</p>
            </div>
            <div className="w-[54%] relative pt-4">
              <div className="relative w-full h-12 group">
                <div className="w-full h-full bg-gray-200" />
              </div>
              <div className="absolute -top-0.5 -right-1 z-20">
                <div className="relative group">
                  <div className="text-sm font-bold bg-[#00aef7]/10 px-2 py-0.5 rounded-full border border-[#00aef7]/20 text-[#00aef7] cursor-help">
                    Business Focus
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center w-[54%] self-end -mt-8">
            <p className="text-lg font-bold text-gray-600">Test Industry</p>
          </div>
          <div className="mt-3 flex-1 overflow-y-auto max-h-[300px] pr-2 relative">
            <div className="w-full h-full p-2 pt-8 text-gray-700 bg-white">
              <p className="mb-2">Test about section content...</p>
            </div>
          </div>
        </div>

        {/* Right Column - Reviews & Ratings */}
        <div className="w-full md:w-[35%] bg-white rounded-lg p-4 shadow-[0_0_20px_rgba(0,0,150,0.1)]">
          {/* Reviews content */}
        </div>
      </div>

      {/* Override auth context for testing */}
      <div style={{ position: 'relative' }}>
        <DockingStation 
          isOwner={true} 
          user={mockUser}
          auth={mockAuth}
        />
        {/* Remove the TestProfile component from here */}
      </div>
    </div>
  );
};

export default TestPage;